var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6024_1866)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3.49994C2 2.952 2.44409 2.50781 2.9919 2.50781H12.9109C13.1739 2.50781 13.4262 2.61234 13.6122 2.7984L22.1347 11.3229C22.6889 11.8806 23 12.6349 23 13.4212C23 14.2076 22.6889 14.9619 22.1347 15.5196L22.1326 15.5217L15.0211 22.6349C14.7448 22.9114 14.4164 23.1312 14.0553 23.2809C13.6941 23.4307 13.3069 23.5078 12.9158 23.5078C12.5248 23.5078 12.1375 23.4307 11.7763 23.2809C11.4151 23.1312 11.087 22.9117 10.8107 22.6351L2.29093 14.1232C2.10466 13.9371 2 13.6846 2 13.4212V3.49994Z",
    stroke: "#7F42A3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 8.00781C6 7.17939 6.66823 6.50781 7.49254 6.50781H7.50746C8.33177 6.50781 9 7.17939 9 8.00781C9 8.83624 8.33177 9.50781 7.50746 9.50781H7.49254C6.66823 9.50781 6 8.83624 6 8.00781Z",
    fill: "#7F42A3",
    stroke: "#7F42A3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6024_1866"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.507812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.ce7263cefbe151fe61a307d433e635c2.svg";
export { ForwardRef as ReactComponent };